import { TListingFetchReason, TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS, TRESPONSE_EMPLOYEE_LIST } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TEmployeeManagementState = {
  employeeListingInfo: {
    res: TRESPONSE_EMPLOYEE_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  deleteEmployeeReplacementsFailure: TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS | null;
  employeeListingPagination: TUserPaginationOption;
};

export const TEmployeeManagementActionType = {
  GetEmployeeList: 'GET_EMPLOYEE_LIST' as const,
  GetEmployeeListSuccess: 'GET_EMPLOYEE_LIST_SUCCESS' as const,
  GetEmployeeListFailure: 'GET_EMPLOYEE_LIST_FAILURE' as const,
  SetEmployeeListPagination: 'SET_EMPLOYEE_LIST_PAGINATION' as const,
  UpdateEmployee: 'UPDATE_EMPLOYEE' as const,
  UpdateEmployeeFailure: 'UPDATE_EMPLOYEE_SUCCESS' as const,
  UpdateEmployeeSuccess: 'UPDATE_EMPLOYEE_FAILURE' as const,
  DeleteEmployee: 'DELETE_EMPLOYEE' as const,
  DeleteEmployeeSuccess: 'DELETE_EMPLOYEE_SUCCESS' as const,
  DeleteEmployeeFailure: 'DELETE_EMPLOYEE_FAILURE' as const,
  DeleteEmployeeReplacements: 'DELETE_EMPLOYEE_REPLACEMENTS' as const,
  DeleteEmployeeReplacementsSuccess: 'DELETE_EMPLOYEE_REPLACEMENTS_SUCCESS' as const,
  DeleteEmployeeReplacementsFailure: 'DELETE_EMPLOYEE_REPLACEMENTS_FAILURE' as const,
  UpdateEmployeeManagementPageNo: 'EMPLOYEE_LIST_ACTION_UPDATE_PAGE_NO' as const,
  UpdateEmployeeManagementItemsPerPage: 'EMPLOYEE_LIST_ACTION_UPDATE_ITEMS_PER_PAGE' as const,
};
